import type { IpAssets, SiteTheme } from "~/theme/types";

const IMG = "/images/ip/oneroomta";

export const oneroomtaTheme: SiteTheme = {
  slug: "oneroomta",
  tokens: {
    primary: "#f5a623",
    primarySoft: "rgba(245,166,35,0.15)",
    primaryHover: "#d98c10",
    primaryGlow: "245,166,35",
    bg: "#fffaf3",
    surface: "#fff3e0",
    text: "#3a2a1a",
    textBody: "#8a6a4a",
    textMuted: "#a08868",
  },
};

export const oneroomtaAssets: IpAssets = {
  imagesBase: IMG,
  logos: {
    ko: `${IMG}/logo_kr.webp`,
    en: `${IMG}/logo_en.webp`,
    ja: `${IMG}/logo_ja.webp`,
  },
  logoAlt: {
    ko: "원룸 조교님",
    en: "One-Room TA",
    ja: "원룸 조교님",
  },
  sectionTitles: {
    characters: `${IMG}/title_Characters.webp`,
    news: `${IMG}/title_news.webp`,
    goods: `${IMG}/title_goods.webp`,
  },
  heroVisuals: [
    {
      id: 1,
      bg: `${IMG}/hero_kv1_bg.webp`,
      char: `${IMG}/hero_character.webp`,
      thumb: `${IMG}/kv_a_clean.webp`,
      label: "KEY VISUAL 01",
    },
  ],
  pvVideoIds: {
    ko: "MIGS_dy-teU",
    en: "MIGS_dy-teU",
    ja: "MIGS_dy-teU",
  },
  pvPreview: `${IMG}/pv_preview.mp4`,
  pvPreviewByLocale: {
    ko: `${IMG}/pv_preview.mp4`,
  },
  laftelOnly: `${IMG}/laftel_only.webp`,
  loading: {
    assets: [`${IMG}/hero_kv1_bg.webp`, `${IMG}/hero_character.webp`, `${IMG}/logo_kr.webp`],
    logoSrc: `${IMG}/logo_kr.webp`,
    logoAlt: "원룸 조교님",
  },
};
